<p-confirmDialog
  [appendTo]="'body'"
  [style]="{ width: '30vw' }"></p-confirmDialog>
